<div
  class="inline-warning-banner"
  role="alert"
  [class.inline-warning-banner-fixed]="fixed"
  [class.mat-elevation-z4]="elevation"
  [class.is-pinned-shadow]="showPinnedShadow && effectivePinned"
  [style.top.px]="fixed ? topPx : null"
  [style.left.px]="fixed ? leftPx : null"
  [style.width.px]="fixed ? widthPx : null"
>
  <div class="inline-warning-icon">
    <mat-icon class="material-icons-outlined">{{ icon }}</mat-icon>
  </div>

  <div class="inline-warning-text">
    <div class="inline-warning-title">{{ title }}</div>
    <div class="inline-warning-body">{{ message }}</div>
  </div>

  <button
    *ngIf="closable"
    type="button"
    class="inline-warning-close"
    (click)="onCloseClicked()"
    aria-label="Dismiss warning"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
